import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { ErrorResponse, ServerError } from './ErrorResponse';
export class SignatureErrorResponse {
    isCompletedDocumentNotAvailable() {
        return this.error.hasServerError(ServerError.CompletedDocumentNotAvailable);
    }
    isExpectedFieldsRefusal() {
        return this.error.hasServerError([
            ServerError.LegalTermsSignatureNotEnabled,
            ServerError.LegalTermsNotFound,
            ServerError.DocusealUnavailable
        ]);
    }
    signingSessionRefusal() {
        if (this.error.hasServerError(ServerError.NotASignerOnThisDocument)) return 'notASigner';
        if (this.error.hasServerError([
            ServerError.RelationshipNotAwaitingApproval,
            ServerError.ProposalBeingEdited
        ])) {
            return 'statusChanged';
        }
        if (this.error.hasServerError(ServerError.SigningClosedForSigner)) return 'closed';
        return 'unavailable';
    }
    constructor(error){
        _define_property(this, "error", void 0);
        this.error = error instanceof ErrorResponse ? error : new ErrorResponse(error);
    }
}
